export default "__VITE_ASSET__DYKHDeMY__"